<!-- 获取验证码滑块组件 -->
<template>
	<div class="commonDialog position-fixed top-0 left-0 width-screen height-all flex justify-center"
		v-if="isShowVerifyDialog" @click="closeVerifyCover">
		<div class="container dialogCon" @click.stop @mousemove.prevent="move" @touchmove.prevent="move"
			@mouseup.prevent="drop" @touchend.prevent="drop">
			<div id="captcha" style="position: relative">
				<canvas id="original" :width="w" :height="h"></canvas>
				<canvas id="duplicate" class="position-absolute top-0 left-0" :height="h"></canvas>
				<div class="sliderTips position-absolute top-0 left-0 flex flex-column justify-center align-center"
					:style="{width: w + 'px', height: h + 'px'}" v-if="refreshCounter > 10">
					<img src="@/static/images/icon_warning_empty.png" alt="">
					<span>验证过于频繁，请稍后重试</span>
				</div>
				<div class="sliderTips position-absolute top-0 left-0 flex flex-column justify-center align-center"
					:style="{width: w + 'px', height: h + 'px'}" v-if="refreshOver">
					<img class="rotate" src="@/static/images/icon_arrow_refresh.png" alt="">
					<span>图片加载中...</span>
				</div>
				<div class="sliderContainer">
					<div class="sliderMask" :style="{width: sliderMaskWidth + 'px'}">
						<div class="slider" :style="{pointerEvents: refreshCounter > 10 ? 'none' : 'initial'}"
							@mousedown.prevent="drag" @touchstart.prevent="drag">
							<span class="sliderIcon"></span>
						</div>
					</div>
					<span class="sliderText">向右滑动滑块填充拼图</span>
				</div>
				<!--<div class="refreshIcon" @click="reset"></div>-->
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: {
		    isShowVerifyDialog: {
		        type: Boolean,
		        default: false
		    }
		},
		data() {
		    return {
		        originalCanvas: null,
		        duplicateCanvas: null,
		        originalCtx: null,
		        duplicateCtx: null,
		        slider: null,
		        sliderContainer: null,
		        img: null,
		        refreshOver: false,
		        refreshCounter: 1,
		        y: 0,
		        PI: Math.PI,
		        l: 42, // 滑块边长
		        r: 10, // 滑块半径
		        w: 310, // canvas宽度
		        h: 155, // canvas高度
		        L: 62, // 滑块实际边长
		        sliderMaskWidth: 0,
		        originX: 0,
		        originY: 0,
		        trail: [],
		        isMouseDown: false,
		    }
		},
		watch: {
		    isShowVerifyDialog: function (newValue) {
		        if (newValue) {
		            setTimeout(() => this.initCanvas(), 200)
		        }else {
		            this.destroy();
		            this.refreshCounter = 1;
		        }
		    }
		},
		methods: {
		    /**
		     * 显示验证弹窗
		     */
		    showVerifyCover(){
		        this.$emit("show-verify-cover", true);
		    },
		    /**
		     * 关闭验证弹窗
		     */
		    closeVerifyCover(){
		        this.$emit("close-verify-cover", false);
		    },
		    /**
		     * 滑块验证 两数相加并返回结果
		     */
		    sum(x, y) {
		        return x + y
		    },
		    /**
		     * 滑块验证 两数乘积并返回结果
		     */
		    square(x) {
		        return x * x
		    },
		    /**
		     * 滑块验证 产生随机数并返回结果
		     */
		    getRandomNumberByRange(start, end) {
		        return Math.round(Math.random() * (end - start) + start)
		    },
		    /**
		     * 滑块验证 创建节点并返回节点
		     */
		    createElement(tagName) {
		        return document.createElement(tagName)
		    },
		    /**
		     * 滑块验证 产生随机图片链接并返回
		     */
		    getRandomImg() {
		        // return 'https://picsum.photos/300/150/?image=' + this.getRandomNumberByRange(0, 100)
		        var index = Math.floor(Math.random() * 5) + 1;
		        var sliderImgUrl = './sliderImg/sliderImg' + index + '.jpg';
				// var sliderImgUrl = 'https://douyin.meiyintutu.com/pages/images/sliderImg/sliderImg' + index + '.jpg'
		        return sliderImgUrl;
		    },
		    /**
		     * 滑块验证 添加类名
		     */
		    addClass(tag, className) {
		        tag.classList.add(className)
		    },
		    /**
		     * 滑块验证 移除类名
		     */
		    removeClass(tag, className) {
		        tag.classList.remove(className)
		    },
		    /**
		     * 滑块验证 创建Img标签
		     */
		    createImg(onload) {
		        // $.showMaskLoading();
		        let that = this;
		        that.refreshOver = true;
		        let img = that.createElement('img');
		        img.crossOrigin = "Anonymous";
		        img.onload = onload;
		        img.onerror = () => {
		            img.src = that.getRandomImg();
		        };
		        img.src = that.getRandomImg();
		        return img
		    },
		    /**
		     * 滑块验证 绘制抠图区域
		     */
		    drawCanvas(ctx, operation, x, y) {
		        let that = this;
		        ctx.beginPath();
		        ctx.moveTo(x, y);
		        ctx.lineTo(x + that.l / 2, y);
		        ctx.arc(x + that.l / 2, y - that.r + 2, that.r, 0, 2 * that.PI);
		        ctx.lineTo(x + that.l / 2, y);
		        ctx.lineTo(x + that.l, y);
		        ctx.lineTo(x + that.l, y + that.l / 2);
		        ctx.arc(x + that.l + that.r - 2, y + that.l / 2, that.r, 0, 2 * that.PI);
		        ctx.lineTo(x + that.l, y + that.l / 2);
		        ctx.lineTo(x + that.l, y + that.l);
		        ctx.lineTo(x, y + that.l);
		        ctx.lineTo(x, y);
		        ctx.fillStyle = '#fff';
		        ctx[operation]();
		        ctx.beginPath();
		        ctx.arc(x, y + that.l / 2, that.r, 1.5 * that.PI, 0.5 * that.PI);
		        ctx.globalCompositeOperation = "xor";
		        ctx.fill();
		    },
		    /**
		     * 滑块验证 初始化滑块验证
		     */
		    initCanvas() {
		        let that = this;
		        that.originalCanvas = document.querySelector('#original');
		        that.duplicateCanvas = document.querySelector('#duplicate');
		        that.sliderContainer = document.querySelector('.sliderContainer');
		        that.slider = document.querySelector('.slider');
		        that.originalCtx = that.originalCanvas.getContext('2d');
		        that.duplicateCtx = that.duplicateCanvas.getContext('2d');
		        that.draw();
		        let img = that.createImg(function() {
		            that.originalCtx.drawImage(img, 0, 0, that.w, that.h);
		            that.duplicateCtx.drawImage(img, 0, 0, that.w, that.h);
		            let y = that.y - that.r * 2 + 2;
		            let ImageData = that.duplicateCtx.getImageData(that.x, y, that.L, that.L);
		            that.duplicateCanvas.width = that.L;
		            that.duplicateCtx.putImageData(ImageData, 0, y);
		            that.refreshOver = false;
		        });
		        that.img = img;
		    },
		    /**
		     * 滑块验证 随机创建滑块的位置
		     */
		    draw() {
		        let that = this;
		        // 随机创建滑块的位置
		        that.x = that.getRandomNumberByRange(that.L + 10, that.w - (that.L + 10));
		        that.y = that.getRandomNumberByRange(10 + that.r * 2, that.h - (that.L + 10));
		        that.drawCanvas(that.originalCtx, 'fill', that.x, that.y);
		        that.drawCanvas(that.duplicateCtx, 'clip', that.x, that.y)
		    },
		    /**
		     * 滑块验证 滑块mousedown事件
		     */
		    drag(e) {
		        let that = this;
		        that.originX = e.x || e.touches[0].screenX;
		        that.originY = e.y || e.touches[0].screenY;
		        that.trail = [];
		        that.isMouseDown = true;
		    },
		    /**
		     * 滑块验证 滑块mousemove事件
		     */
		    move(e) {
		        let that = this;
		        if(!that.isMouseDown) return false;
		        let moveX = (e.x || e.changedTouches[0].screenX) - that.originX,
		            moveY = (e.y || e.changedTouches[0].screenY) - that.originY;
		        if(moveX < 0 || moveX + 40 >= that.w) return false;
		        that.slider.style.left = moveX + 'px';
		        let blockLeft = (that.w - 40 - 22) / (that.w - 40) * moveX;
		        that.duplicateCanvas.style.left = blockLeft + 'px';
		        that.addClass(that.sliderContainer, 'sliderContainer_active');
		        that.sliderMaskWidth = moveX + 2;
		        that.trail.push(moveY);
		    },
		    /**
		     * 滑块验证 滑块mouseup事件
		     */
		    drop(e) {
		        let that = this;
		        if(!that.isMouseDown) return false;
		        that.isMouseDown = false;
		        if((e.x || e.changedTouches[0].screenX) == that.originX) return false;
		        that.removeClass(that.sliderContainer, 'sliderContainer_active');
		        let { spliced, TuringTest } = that.verify();
		        if(spliced) {
		            if(TuringTest) {
		                // alert("验证成功");
		                that.verifySuccess();
		            } else {
		                // alert("验证失败");
		                that.verifyFail();
		            }
		        } else {
		            // alert("验证失败");
		            that.verifyFail();
		        }
		    },
		    /**
		     * 滑块验证 验证滑块位置并返回结果
		     */
		    verify() {
		        let that = this;
		        let arr = that.trail; // 拖动时y轴的移动距离
		        let average = arr.reduce(that.sum) / arr.length; // 平均值
		        let deviations = arr.map(x => x - average); // 偏差数组
		        let stddev = Math.sqrt(deviations.map(that.square).reduce(that.sum) / arr.length); // 标准差
		        let left = parseInt(that.duplicateCanvas.style.left);
		        return {
		            spliced: Math.abs(left - this.x) < 10,
		            TuringTest: average !== stddev, // 只是简单的验证拖动轨迹，相等时一般为0，表示可能非人为操作
		        }
		    },
		    /**
		     * 滑块验证 成功回调
		     */
		    verifySuccess() {
		        let that = this;
		        that.addClass(that.sliderContainer, 'sliderContainer_success');
		        that.$emit('verify-success-callback');
		    },
		    /**
		     * 滑块验证 失败回调
		     */
		    verifyFail() {
		        let that = this;
		        that.addClass(that.sliderContainer, 'sliderContainer_fail');
		        that.$message({
		            message: "验证失败，请重新验证",
		            duration: 1000,
		            onClose: function () {
		                that.reset();
		            }
		        });
		        that.isMouseDown = false;
		    },
		    /**
		     * 滑块验证 清空画布
		     */
		    clean() {
		        this.originalCtx.clearRect(0, 0, this.w, this.h);
		        this.duplicateCtx.clearRect(0, 0, this.w, this.h);
		        this.duplicateCanvas.width = this.w;
		    },
		    /**
		     * 滑块验证 重置滑动图片
		     */
		    reset() {
		        let that = this;
		        that.refreshOver = true;
		        that.refreshCounter += 1;
		        that.sliderContainer.className = 'sliderContainer';
		        that.slider.style.left = 0;
		        that.duplicateCanvas.style.left = 0;
		        that.sliderMaskWidth = 0;
		        that.clean();
		        if (that.refreshCounter > 10){
		            return that.refreshOver = false;
		        } else {
		            that.img.src = that.getRandomImg();
		            that.draw();
		        }
		    },
		    /**
		     * 滑块验证 销毁滑块验证
		     */
		    destroy() {
		        this.clean();
		        this.sliderContainer.className = 'sliderContainer';
		        this.slider.style.left = 0;
		        this.duplicateCanvas.style.left = 0;
		        this.sliderMaskWidth = 0;
		        this.originalCanvas = null;
		        this.duplicateCanvas = null;
		        this.originalCtx = null;
		        this.duplicateCtx = null;
		        this.slider = null;
		        this.sliderContainer = null;
		        this.img = null;
		        this.d = 0;
		        this.trail = [];
		        this.isMouseDown = false;
		    },
		}
	}
</script>

<style>
</style>